import React, { FC, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Button, Select, Collapse, Image } from "antd";
import { ReactSVG } from "react-svg";
import { UploadOutlined, CloudDownloadOutlined } from "@ant-design/icons";
import _ from "lodash";
import { Form } from "antd";
import { useLocation } from "react-router-dom";
import { SocketTopics, UserTopics } from "constants/enums";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import {
  getProjectsRequestPublishTopic,
  getProjectsSubscriptionTopic,
  getRespondersSubscriptionTopic,
  getAssetsSubscriptionTopic,
  getCreateEventPageSubscriptionTopic,
  getCreateEventPagePublishTopic,
  getPageRequestPublishTopic,
  getPageSubscriptionTopic,
  getAdminRolesTopic,
  getSearchMessagePublishTopic,
  getSearchMessageSubscriptionTopic,
} from "hooks/MQTTConstants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import {
  SET_CURRENT_PROJECT,
  SET_SUBMITTED,
  ADD_OTHER_LOCATION,
} from "reducers/reducer";
import { pushNotification } from "utils/notifications";
import moment from "moment";
import UploadCSVModal from "./UploadCSVModal";
import useSocketActions from "../../../../hooks/socketActions";
import MultiInput from "../../../../common/MultiInput";
import RenderFields from "../../../../common/RenderFields";
import { formatObject } from "utils/appUtil";
import csvDownload from "json-to-csv-export";
import ScheduleInput from "../../../../common/ScheduleInput";
import { attributeKeyGenerator } from "utils/appUtil";
import NotifyTypeInput from "../../../../common/NotifyTypeInput";
import ConfirmationModal from "../../../../common/Confirmation";
import { generateUUID } from "utils/appUtil";
import Geocode from "react-geocode";
import { GET_AGGREGATE, DECRYPT_TOKEN } from "../../../../reducers/reducer";
import { formatForRedis } from "utils/appUtil";

Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const { Panel } = Collapse;

let customerSearchTimeout;
const DispatchPanel: FC<{
  socket: ISocket;
  params: any;
  date?: Date;
  selectedCustomerId?: string;
  selectedProjectId?: string;
  onEventCreated?: any;
}> = ({ socket, params, date, onEventCreated, selectedCustomerId, selectedProjectId }) => {
  const [nine11Form] = Form.useForm();
  const [error, setError] = useState<string>("");
  const { screens, setScreens } = params;
  const { search } = useLocation();
  const history = useHistory();
  const { messages, encrypted_token } = useSelector((state: RootState) => state.auth);
  const projects = useSelector(
    (state: RootState) => state.auth.projects,
    (a, b) => {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  );
  const dispatch = useDispatch();
  const { getUserRequestPayload, handleMessages } = useSocketActions();
  const [adminRoles, setAdminRoles] = useState();
  const selectedResponders = useSelector(
    (state: RootState) => state.auth.selectedResponders,
    (a, b) => {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  );
  const selectedAssets = useSelector(
    (state: RootState) => state.auth.selectedAssets,
    (a, b) => {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  );
  const submitted = useSelector(
    (state: RootState) => state.auth.submitted,
    (a, b) => {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  );

  const [searching, setSearching] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [pageId, setPageId] = useState<boolean>(false);
  const [assistModalVisible, setAssistModalVisible] = useState<boolean>(false);
  const [assistPageId, setAssistPageId] = useState<any>();
  const [cadSections, setCadSections] = useState([]);
  const [cadExtendedSections, setCadExtendedSections] = useState({
    what: [],
    account: [],
    where: [],
    who: [],
    when: [],
    why: [],
  });
  const [uploadModalVisible, setUploadModalVisible] = useState<boolean>(false);
  const [dispatchType, setDispatchType] = useState<any>();

  const onSubmitHandler = (values: Nine11Values) => {
    setUploadModalVisible(false);
    // const query = new URLSearchParams(search);
    const userId = encrypted_token?.userId;
    const connectionId = encrypted_token?.connectionId;
    const projectId = selectedProjectId || encrypted_token?.projectId;
    let responders = selectedResponders.map((responder) => {
      return {
        id: responder.id,
        beamId: responder.title,
      };
    });
    const assets = selectedAssets.map((asset) => {
      return {
        id: asset.id,
        title: asset.title,
        location: asset.location,
      };
    });
    console.log("values", values);
    if (values["undefined"]) {
      values = { ...values["undefined"], ...values };
      delete values["undefined"];
    }
    const extendedAttributes = {};
    Object.keys(values).map((key) => {
      _.merge(
        extendedAttributes,
        formatObject(key, key, values[key], cadSections, cadExtendedSections)
      );
    });
    let projectKey;
    Object.keys(extendedAttributes).map((key) => {
      if (extendedAttributes?.[key]?.type === "project") {
        projectKey = key;
      }
    });
    const selectedProject =
      projectId && projectId !== ""
        ? projectId
        : extendedAttributes[projectKey]?.id;
    const project = projects?.projects?.find((x) => {
      return x.id === selectedProject;
    });
    const sortedAttributes: any = {
      ...extendedAttributes,
      projectName: project?.name,
      [projectKey || "incidentType"]: {
        id: project?.id,
        type: "project",
      },
    };
    let tempResponders;
    Object.keys(sortedAttributes).map((key) => {
      if (sortedAttributes?.[key]?.type === "responder") {
        tempResponders = sortedAttributes?.[key]?.responders;
      }
    });
    const title = sortedAttributes.title
      ? sortedAttributes.title
      : new Date().toLocaleString();
    if (sortedAttributes.title) {
      delete sortedAttributes.title;
    }
    let tasks;
    let invitation = true;
    let createdAt = new Date().getTime();
    Object.keys(sortedAttributes).map((key) => {
      if (sortedAttributes?.[key]?.type === "task") {
        tasks = sortedAttributes?.[key]?.tasks;
        delete sortedAttributes?.[key];
      }
      if (sortedAttributes?.[key]?.type === "dispatchType") {
        if (sortedAttributes?.[key]?.value === "schedule") {
          sortedAttributes["scheduleDate"] = sortedAttributes?.[key]?.date;
          sortedAttributes["scheduleTime"] = sortedAttributes?.[key]?.time;
          const incidentLocation = Object.keys(sortedAttributes).find((key) => {
            return sortedAttributes?.[key]?.type === "incident-location";
          });
          let eventDescription = "";
          Object.keys(sortedAttributes).map((key) => {
            if (typeof sortedAttributes[key] === "string") {
              eventDescription += `${attributeKeyGenerator(key)}: ${
                sortedAttributes[key]
              }\n`;
            }
          });
          const tempDate = new Date(sortedAttributes?.[key]?.dateTimestamp);
          const tempTime = new Date(sortedAttributes?.[key]?.timeTimestamp);
          tempDate.setHours(tempTime.getHours());
          tempDate.setMinutes(tempTime.getMinutes());
          createdAt = tempDate.getTime();

          if (sortedAttributes.notify) {
            sortedAttributes["notify"].utcDateTime = new Date(
              tempDate.getTime()
            ).toUTCString();
            if (sortedAttributes?.notify?.customTime) {
              sortedAttributes.notify.notifyTime =
                sortedAttributes.notify.customTime.toString();
            }
          }
          sortedAttributes["caseVisitSchedule"] = {
            type: "event",
            dateTime: tempDate.getTime(),
            description: eventDescription,
            location: sortedAttributes[incidentLocation]?.coordinates
              ? {
                  attributes: sortedAttributes[incidentLocation]?.attributes,
                  coordinates: sortedAttributes[incidentLocation]?.coordinates,
                }
              : undefined,
            repeat: false,
            notifyTime: sortedAttributes.notify
              ? new Date(
                  tempDate.getTime() -
                    sortedAttributes?.notify?.notifyTime * 60000
                ).getTime()
              : undefined,
            notifyVia: sortedAttributes?.notify?.notifyVia,
            title,
          };
          invitation = false;
        } else {
          delete sortedAttributes.notify;
        }
        if (sortedAttributes?.[key]?.value === "deadline") {
          sortedAttributes["deadlineDate"] = sortedAttributes?.[key]?.date;
          sortedAttributes["deadlineTime"] = sortedAttributes?.[key]?.time;
          sortedAttributes["deadlineRSVP"] = {
            type: "rsvp",
            subType: "calendar",
            rsvpTitle: `Schedule visit before ${sortedAttributes?.[key]?.date} ${sortedAttributes?.[key]?.time} deadline`,
            startDate: new Date().getTime(),
            endDate: new Date(sortedAttributes?.[key]?.date).getTime(),
          };
          invitation = false;
        }
        delete sortedAttributes?.[key];
      }
    });
    if (tempResponders) {
      responders = [...responders, ...tempResponders];
    }
    setError(undefined);
    setSearching(true);
    if (tasks && tasks.length > 0) {
      tasks.map((task) => {
        let incidentLocationKey = "taskEventLocation";
        Object.keys(sortedAttributes).map((key) => {
          if (sortedAttributes?.[key]?.type === "incident-location") {
            incidentLocationKey = key;
          }
        });
        if (
          (task.locationType === "manual" || task.locationType === "lbs") &&
          task.location?.coordinates?.lat &&
          task.location?.coordinates?.lat !== 0
        ) {
          sortedAttributes[incidentLocationKey] = {
            type: "incident-location",
            ...task.location,
          };
        }
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getCreateEventPagePublishTopic(connectionId),
          wrapRequestPayload({
            userId,
            attributes: {
              taskName: task.name,
              taskDescription: task.description,
              taskDate: task.dateTime
                ? moment(task.dateTime)?.format("MM/DD/YYYY")
                : undefined,
              taskTime: task.dateTime
                ? moment(task.dateTime)?.format("hh:mm A")
                : undefined,
              taskEvent: task.dateTime
                ? {
                    type: "event",
                    dateTime: new Date(task.dateTime).getTime(),
                    description: task.description,
                    location: sortedAttributes[incidentLocationKey]?.coordinates
                      ? {
                          attributes:
                            sortedAttributes[incidentLocationKey]?.attributes,
                          coordinates:
                            sortedAttributes[incidentLocationKey]?.coordinates,
                        }
                      : undefined,
                    repeat: false,
                    title: task.name,
                  }
                : undefined,
              ...sortedAttributes,
            },
            responders,
            assets,
            connectionId,
            pageId: undefined,
            submitted: true,
            unstructuredAttributes: values,
            title,
            invitation,
            assistPageId,
            createdAt,
            cudbServiceId: encrypted_token?.cudbServiceId,
          })
        );
      });
    } else {
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getCreateEventPagePublishTopic(connectionId),
        wrapRequestPayload({
          userId,
          attributes: sortedAttributes,
          responders,
          assets,
          connectionId,
          pageId,
          submitted: true,
          unstructuredAttributes: values,
          title,
          invitation,
          assistPageId,
          createdAt,
          cudbServiceId: encrypted_token?.cudbServiceId,
        })
      );
    }
  };

  useEffect(() => {
    if (submitted) {
      onEventCreated && onEventCreated(nine11Form.getFieldsValue());
      if (searching) {
        setSearching(false);
        setPageId(undefined);
        setAssistPageId(undefined);
        pushNotification(
          "Event page submitted successfully",
          "success",
          "TOP_CENTER",
          1000
        );
        localStorage.removeItem("form");
        localStorage.removeItem("active");
        setTimeout(() => {
          nine11Form.resetFields();
        }, 500);
        setScreens({
          ...screens,
          map: false,
        });
        // const query = new URLSearchParams(search);
        // query.delete("pageId");
        // query.delete("assistPageId");
        // history.replace({
        //   search: query.toString(),
        // });
        dispatch({ type: SET_SUBMITTED, payload: false });
      } else if (saving) {
        setSaving(false);
        setPageId(submitted.pageId);
        pushNotification(
          "Event page saved successfully",
          "success",
          "TOP_CENTER",
          1000
        );
        // const query = new URLSearchParams(search);
        // query.delete("pageId");
        // query.append("pageId", submitted.pageId);
        // history.replace({
        //   search: query.toString(),
        // });
      }
    }
  }, [
    dispatch,
    history,
    nine11Form,
    saving,
    screens,
    search,
    searching,
    setScreens,
    submitted,
  ]);

  useEffect(() => {
    if (projects?.sections) {
      // const query = new URLSearchParams(search);
      const projectId = selectedProjectId || encrypted_token?.projectId;
      const assistPage = encrypted_token?.assistPageId;
      const connectionId = encrypted_token?.connectionId;
      if (assistPage) {
        setAssistModalVisible(true);
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          getSearchMessageSubscriptionTopic(assistPage, connectionId)
        );
        getMessages(assistPage);
      }
      let sections =
        projectId && projectId !== ""
          ? projects?.sections?.[1]?.[0]?.[projectId] || []
          : projects?.sections?.[0]?.[0];
      let tempCadExtendedSection = { ...cadExtendedSections };
      sections?.map((section) => {
        if (tempCadExtendedSection[section.sectionName.toLowerCase()]) {
          tempCadExtendedSection[section.sectionName.toLowerCase()] =
            section?.Rows;
        }
      });

      const tempCadSections =
        sections.filter((section) => {
          return (
            Object.keys(cadExtendedSections).indexOf(
              section.sectionName.toLowerCase()
            ) === -1
          );
        }) || [];

      setCadExtendedSections(tempCadExtendedSection);
      setCadSections(tempCadSections);

      let dispatchTypeField;
      let customerSearchField;
      Object.keys(tempCadExtendedSection).map((section) => {
        tempCadExtendedSection[section].map((row) => {
          row?.Cols?.map((col) => {
            if (col?.type === "dispatchType") {
              dispatchTypeField = col;
            }
            if (col?.type === "customer-search") {
              customerSearchField = col;
            }
          });
        });
      });
      tempCadSections?.map((section) => {
        section.Rows.map((row) => {
          row?.Cols?.map((col) => {
            if (col?.type === "dispatchType") {
              dispatchTypeField = col;
            }
            if (col?.type === "customer-search") {
              customerSearchField = col;
            }
          });
        });
      });

      console.log("dispatch type field", dispatchTypeField);
      if (dispatchTypeField && date) {
        nine11Form.setFieldsValue({
          undefined: {
            [dispatchTypeField.name]: {
              type: "dispatchType",
              value: "schedule",
              date,
              time: date,
            },
          },
        });
      }

      console.log(
        "customer search field",
        customerSearchField,
        selectedCustomerId,
        selectedCustomerId !== undefined && selectedCustomerId !== ""
      );

      if (customerSearchField && selectedCustomerId) {
        console.log("selected customer id", selectedCustomerId);
        getCustomer({
          itemName: [customerSearchField.name],
          value: selectedCustomerId,
        });
      }
    }

    if (projects?.adminUserId) {
      getAdminRoles(projects?.adminUserId, projects?.userServiceId);
    }
  }, [projects]);

  const getAdminRoles = (adminUserId, cudbServiceId) => {
    // const query = new URLSearchParams(search);
    // const connectionId = query.get("connectionId");
    socket.publishToServiceIdSurvey(
      SocketTopics.SurveyTopics,
      UserTopics.SearchInUser,
      getUserRequestPayload(adminUserId, "$", "$..role"),
      getAdminRolesTopic(encrypted_token?.connectionId),
      cudbServiceId
    );
    socket.subscribeToSurvey(
      SocketTopics.SurveyTopics,
      getAdminRolesTopic(encrypted_token?.connectionId),
      (response) => {
        setAdminRoles(response.data?.[0]?.[0]);
      }
    );
  };

  useEffect(() => {
    if (socket.client) {
      const query = new URLSearchParams(search);
      const userId = query.get("userId");
      const connectionId = query.get("connectionId");
      const projectId = query.get("projectId");
      const pageId = query.get("pageId");
      const assistPageId = query.get("assistPageId");
      const cudbServiceId = query.get("cudbServiceId");
      const token = query.get("token");
      if (token) {
        dispatch(
          DECRYPT_TOKEN({
            data: { payload: token },
            callback: (data) => {},
          })
        );
      } else {
        dispatch({
          type: "ADD_ENCRYPTED_TOKEN",
          payload: {
            connectionId,
            userId,
            projectId,
            pageId,
            assistPageId,
            cudbServiceId
          },
        });
      }
    }
  }, [search, socket.client]);

  useEffect(() => {
    if (encrypted_token) {
      // const query = new URLSearchParams(search);
      // const userId = query.get("userId");
      // const connectionId = query.get("connectionId");
      // const pageId = query.get("pageId");
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getProjectsSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getRespondersSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getAssetsSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getCreateEventPageSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getPageSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getProjectsRequestPublishTopic(encrypted_token?.connectionId),
        wrapRequestPayload({
          userId: encrypted_token?.userId,
          cudbServiceId: encrypted_token?.cudbServiceId,
        })
      );
      if (encrypted_token?.pageId) {
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getPageRequestPublishTopic(encrypted_token?.connectionId),
          wrapRequestPayload({
            objectId: encrypted_token?.pageId,
            paths: ["$"],
            returnPaths: ["$"],
          })
        );
      }
    }
  }, [encrypted_token]);

  const onProjectChange = (projectId) => {
    dispatch({ type: SET_CURRENT_PROJECT, payload: projectId });
    const values = nine11Form.getFieldsValue();
    Object.keys(values["undefined"] || {}).map((key) => {
      if (values["undefined"]?.[key]?.type === "task-picker") {
        nine11Form.setFieldsValue({
          undefined: {
            ...values["undefined"],
            [key]: undefined,
          },
        });
      }
    });
  };

  const getCustomer = (customerId) => {
    if (customerSearchTimeout) clearTimeout(customerSearchTimeout);
    customerSearchTimeout = setTimeout(() => {
      const customerRequest: any = {
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:custom:id`,
            // searchIndex: "beamdev:custom:id",
            searchQuery: `@partitions:{'org\\:${formatForRedis(
              projects?.userServiceId
            )}'}`,
            searchOptions: "VERBATIM TIMEOUT 10000",
          },
          load: {
            info: "$.info",
            id: "$.info.id",
            objectId: "$.objectId",
          },
        },
        filter: {
          expression: `exists(@id) && @id==='${customerId?.value}'`,
        },
      };
      dispatch(
        GET_AGGREGATE({
          requestData: customerRequest,
          callback: (response) => {
            // console.log('customer response', response)
            const customer = response?.[0];
            if (customer) {
              console.log("customer response", customer);

              // const pickupLocation = customer?.info?.passenger?.lastPickupLocation
              //   ? {
              //       type: "incident-location",
              //       label:
              //         customer?.info?.passenger?.lastPickupLocation?.attributes
              //           ?.address,
              //       value: {
              //         description:
              //           customer?.info?.passenger?.lastPickupLocation?.attributes
              //             ?.address,
              //         place_id: "",
              //         coordinates:
              //           customer?.info?.passenger?.lastPickupLocation
              //             ?.coordinates,
              //       },
              //     }
              //   : undefined;

              console.log("ite, name", customerId);

              const customerObj = customer?.info?.customer;
              Object.keys(customerObj).map((x) => {
                if (customerObj?.[x]?.type === "location") {
                  customerObj[x] = {
                    type: "location",
                    label: customerObj?.[x]?.attributes?.address,
                    value: {
                      description: customerObj?.[x]?.attributes?.address,
                      placeId: "",
                      coordinates: customerObj?.[x]?.coordinates,
                    },
                  };
                }
              });

              nine11Form.setFieldsValue({
                undefined: {
                  [customerId?.itemName?.[0] || customerId?.itemName?.[1]]:
                    customer?.info?.id,
                  ...customer?.info?.customer,
                },
              });

              // if (pickupLocation) {
              //   addOtherLocation({ pickupLocation });
              //   setScreens({
              //     ...screens,
              //     map: true,
              //   });
              //   getFixedFareByLocation(pickupLocation);
              //   getBlockedAreaByLocation(pickupLocation);
              // }
            }
          },
        })
      );
    }, 500);
  };

  const getMessages = (pageId) => {
    const requestId = generateUUID();
    localStorage.setItem("requestId", requestId);
    localStorage.setItem("requestService", "summary");
    const messageRequest: any = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:message:createdAt`,
          searchQuery: `@pageId:{${pageId.toString()}}@type:{'place'}`,
          searchOptions: "TIMEOUT 100",
        },
        load: { object: "$" },
      },
      operations: [
        {
          sortBy: {
            properties: [
              {
                field: "@createdAt",
                order: "DESC",
              },
            ],
          },
        },
      ],
      result: {
        pagination: {
          offset: 0,
          limit: 1,
        },
      },
      sortBy: {
        properties: [
          {
            field: "@createdAt",
            order: "DESC",
          },
        ],
        max: 10000,
      },
    };
    dispatch(
      GET_AGGREGATE({
        requestData: messageRequest,
        callback: (response) => {
          console.log("message response", response);
          handleMessages(requestId, response);
        },
      })
    );
  };

  const reverseGeocode = (locationFieldName: string, marker: any) => {
    Geocode.fromLatLng(marker.coordinates.lat, marker.coordinates.long).then(
      (response) => {
        const values = nine11Form.getFieldsValue();
        nine11Form.setFieldsValue({
          undefined: {
            ...values["undefined"],
            [locationFieldName]: {
              label: marker.attributes.address,
              value: {
                ...response?.results?.[0],
                coordinates: marker.coordinates,
              },
              type: "incident-location",
            },
          },
        });
        addOtherLocation({
          [locationFieldName]: {
            label: marker.attributes.address,
            value: {
              ...response?.results?.[0],
              coordinates: marker.coordinates,
            },
            type: "incident-location",
          },
        });
        setScreens({
          ...screens,
          map: true,
          form: window.innerWidth >= 700,
        });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  useEffect(() => {
    if (messages && messages.length > 0) {
      console.log("messages here", messages);
      let locationField;
      Object.keys(cadExtendedSections).map((section) => {
        cadExtendedSections[section].map((row) => {
          row?.Cols?.map((col) => {
            if (col?.type === "incident-location") {
              locationField = col;
            }
          });
        });
      });
      cadSections?.map((section) => {
        section.Rows.map((row) => {
          row?.Cols?.map((col) => {
            if (col?.type === "incident-location") {
              locationField = col;
            }
          });
        });
      });
      console.log("location field", locationField);
      if (locationField) {
        reverseGeocode(locationField?.name, messages?.[0]?.data);
      }
    }
  }, [messages]);

  const addOtherLocation = (location) => {
    dispatch({ type: ADD_OTHER_LOCATION, payload: location });
    nine11Form.setFieldsValue({
      incidentType: undefined,
    });
    dispatch({
      type: SET_CURRENT_PROJECT,
      payload: undefined,
    });
  };

  const generateCSVFile = () => {
    const headers: string[] = ["title", "location-lat", "location-long"];
    // const query = new URLSearchParams(search);
    const projectId = selectedProjectId || encrypted_token?.projectId;
    let sections =
      projectId && projectId !== ""
        ? projects?.sections?.[1]?.[0]?.[projectId] || []
        : projects?.sections?.[0]?.[0];
    sections.forEach((section: any) => {
      section.Rows.forEach((row: any) => {
        row.Cols.forEach((col: any) => {
          headers.push(col.name);
        });
      });
    });
    headers.push("dispatchType");
    headers.push("dispatchDate");
    headers.push("dispatchTime");
    headers.push("&nbsp;");
    const dataToConvert = {
      data: [],
      filename: "event_template",
      delimiter: ",",
      headers: headers,
    };
    csvDownload(dataToConvert);
  };

  return (
    <div className="main-column ride-dispatch-panel mobile-responsive mr-4">
      {uploadModalVisible && (
        <UploadCSVModal
          onClose={() => {
            setUploadModalVisible(false);
          }}
          adminRoles={adminRoles}
          onSubmitHandler={onSubmitHandler}
        />
      )}
      <div className="main-content">
        <Form
          className="auth-form"
          name="register-form"
          // initialValues={JSON.parse(localStorage.getItem("form") || "{}")}
          initialValues={{}}
          id="register-form"
          layout="vertical"
          form={nine11Form}
          onFinish={onSubmitHandler}
          requiredMark={false}
          onValuesChange={(value, allValues) => {
            localStorage.setItem("form", JSON.stringify(allValues));
          }}
        >
          <div className="main-header">
            <div className="d-flex">
              <Image src="/images/incident-icon.png" preview={false} />
              <h3 className="ml-3">CPC</h3>
            </div>
            <div className="d-flex">
              {/* {!date && (
                <React.Fragment>
                  <UploadOutlined
                    onClick={() => {
                      setUploadModalVisible(true);
                    }}
                    style={{
                      color: "#869cbd",
                      fontSize: 20,
                      cursor: "pointer",
                      marginRight: 0,
                    }}
                  />

                  <CloudDownloadOutlined
                    onClick={() => {
                      generateCSVFile();
                    }}
                    style={{
                      color: "#869cbd",
                      fontSize: 20,
                      cursor: "pointer",
                      marginLeft: "1rem",
                    }}
                  />
                </React.Fragment>
              )} */}

              <ReactSVG
                src="/images/map.svg"
                className="close-icon mr-3"
                onClick={() => {
                  setScreens({
                    ...screens,
                    map: true,
                    form: window.innerWidth >= 700,
                  });
                }}
              />

              {!date && (
                <ReactSVG
                  src="/images/close-icon.svg"
                  className="close-icon"
                  onClick={() => {
                    setTimeout(() => {
                      localStorage.removeItem("form");
                      localStorage.removeItem("form");
                      dispatch({ type: SET_SUBMITTED, payload: false });
                      nine11Form.resetFields();
                      setScreens({
                        ...screens,
                        map: false,
                      });
                      // const query = new URLSearchParams(search);
                      // query.delete("pageId");
                      // history.replace({
                      //   search: query.toString(),
                      // });
                    });
                  }}
                />
              )}
            </div>
          </div>
          <Row className="mt-3">
            <Col span={24}>
              <Form.Item name="feature">
                <Select className="w-full" placeholder="Features"></Select>
              </Form.Item>
            </Col>
          </Row>
          <div className="main-cards">
            <Collapse
              activeKey={[
                "account",
                "where",
                "what",
                "who",
                "when",
                "why",
                ...(cadSections?.map((section) => {
                  return section.sectionName;
                })),
              ]}
              bordered={false}
              className="simple-collapse"
              onChange={(active) => {
                localStorage.setItem("active", JSON.stringify(active));
              }}
            >
              {cadExtendedSections?.["account"]?.length > 0 && (
                <Panel
                  header={
                    <div className="d-flex">
                      <ReactSVG src="/images/account-icon.svg" />
                      <h5 className="ml-3">Account</h5>
                    </div>
                  }
                  key="account"
                >
                  <div className="sub-cards-2">
                    {cadExtendedSections?.["account"]?.map((row, j) => (
                      <Row className={"mt-3"} key={j}>
                        {row?.Cols.map((col, k) => (
                          <Col
                            span={col.ColSize}
                            className={k !== row?.Cols.length - 1 && "pr-2"}
                            xs={24}
                            sm={col.ColSize}
                            key={k}
                          >
                            <RenderFields
                              data={col}
                              projects={projects}
                              addOtherLocation={addOtherLocation}
                              onProjectChange={onProjectChange}
                              onCustomerSearch={getCustomer}
                              customerDisabled={
                                selectedCustomerId !== undefined &&
                                selectedCustomerId !== ""
                              }
                              dispatchDisabled={date !== undefined}
                              adminRoles={adminRoles}
                            />
                          </Col>
                        ))}
                      </Row>
                    ))}
                  </div>
                </Panel>
              )}

              {cadExtendedSections?.["what"]?.length > 0 && (
                <Panel
                  header={
                    <div className="d-flex">
                      <ReactSVG src="/images/pause-icon.svg" />
                      <h5 className="ml-3">What</h5>
                    </div>
                  }
                  key="what"
                >
                  <div className="sub-cards-2">
                    {cadExtendedSections?.["what"]?.map((row, j) => (
                      <Row className={"mt-3"} key={j}>
                        {row?.Cols.map((col, k) => (
                          <Col
                            span={col.ColSize}
                            className={k !== row?.Cols.length - 1 && "pr-2"}
                            xs={24}
                            sm={col.ColSize}
                            key={k}
                          >
                            <RenderFields
                              data={col}
                              projects={projects}
                              addOtherLocation={addOtherLocation}
                              onProjectChange={onProjectChange}
                              onCustomerSearch={getCustomer}
                              adminRoles={adminRoles}
                              customerDisabled={
                                selectedCustomerId !== undefined &&
                                selectedCustomerId !== ""
                              }
                              dispatchDisabled={date !== undefined}
                            />
                          </Col>
                        ))}
                      </Row>
                    ))}
                  </div>
                </Panel>
              )}

              {cadExtendedSections?.["where"]?.length > 0 && (
                <Panel
                  header={
                    <div className="d-flex">
                      <ReactSVG src="/images/geo-icon.svg" />
                      <h5 className="ml-3">Where</h5>
                    </div>
                  }
                  key="where"
                >
                  <div className="sub-cards-2">
                    {cadExtendedSections?.["where"]?.map((row, j) => (
                      <Row className={"mt-3"} key={j}>
                        {row?.Cols.map((col, k) => (
                          <Col
                            span={col.ColSize}
                            className={k !== row?.Cols.length - 1 && "pr-2"}
                            xs={24}
                            sm={col.ColSize}
                            key={k}
                          >
                            <RenderFields
                              data={col}
                              projects={projects}
                              addOtherLocation={addOtherLocation}
                              onProjectChange={onProjectChange}
                              onCustomerSearch={getCustomer}
                              adminRoles={adminRoles}
                              customerDisabled={
                                selectedCustomerId !== undefined &&
                                selectedCustomerId !== ""
                              }
                              dispatchDisabled={date !== undefined}
                            />
                          </Col>
                        ))}
                      </Row>
                    ))}
                  </div>
                </Panel>
              )}

              {cadExtendedSections?.["when"]?.length > 0 && (
                // projects?.sections && (
                <Panel
                  header={
                    <div className="d-flex">
                      <ReactSVG src="/images/clock.svg" />
                      <h5 className="ml-3">When</h5>
                    </div>
                  }
                  key="when"
                >
                  <div className="sub-cards-2">
                    {/* <Form.Item
                      name="dispatch"
                      rules={[{ required: true, message: "**Required Field" }]}
                    >
                      <ScheduleInput
                        placeholder="Dispatch type"
                        onChange={(value) => {
                          setDispatchType(value.value);
                        }}
                      />
                    </Form.Item> */}
                    {/* 
                    {dispatchType === "schedule" && (
                      <Row>
                        <Col span={24}>
                          <Form.Item
                            name="notify"
                            // rules={[{ required: true, message: "**Required Field" }]}
                          >
                            <NotifyTypeInput onChange={(value) => {}} />
                          </Form.Item>
                        </Col>
                      </Row>
                    )} */}

                    {cadExtendedSections?.["when"]?.map((row, j) => (
                      <Row className={"mt-3"} key={j}>
                        {row?.Cols.map((col, k) => (
                          <Col
                            span={col.ColSize}
                            className={k !== row?.Cols.length - 1 && "pr-2"}
                            xs={24}
                            sm={col.ColSize}
                            key={k}
                          >
                            <RenderFields
                              data={col}
                              projects={projects}
                              addOtherLocation={addOtherLocation}
                              onProjectChange={onProjectChange}
                              onCustomerSearch={getCustomer}
                              adminRoles={adminRoles}
                              customerDisabled={
                                selectedCustomerId !== undefined &&
                                selectedCustomerId !== ""
                              }
                              dispatchDisabled={date !== undefined}
                            />
                          </Col>
                        ))}
                      </Row>
                    ))}
                  </div>
                </Panel>
              )}

              {cadExtendedSections?.["why"]?.length > 0 && (
                <Panel
                  header={
                    <div className="d-flex">
                      <ReactSVG src="/images/why.svg" />
                      <h5 className="ml-3">Why</h5>
                    </div>
                  }
                  key="why"
                >
                  <div className="sub-cards-2">
                    {cadExtendedSections?.["why"]?.map((row, j) => (
                      <Row className={"mt-3"} key={j}>
                        {row?.Cols.map((col, k) => (
                          <Col
                            span={col.ColSize}
                            className={k !== row?.Cols.length - 1 && "pr-2"}
                            xs={24}
                            sm={col.ColSize}
                            key={k}
                          >
                            <RenderFields
                              data={col}
                              projects={projects}
                              addOtherLocation={addOtherLocation}
                              onProjectChange={onProjectChange}
                              onCustomerSearch={getCustomer}
                              adminRoles={adminRoles}
                              customerDisabled={
                                selectedCustomerId !== undefined &&
                                selectedCustomerId !== ""
                              }
                              dispatchDisabled={date !== undefined}
                            />
                          </Col>
                        ))}
                      </Row>
                    ))}
                  </div>
                </Panel>
              )}

              {cadExtendedSections?.["who"]?.length > 0 && (
                <Panel
                  header={
                    <div className="d-flex">
                      <ReactSVG src="/images/user1-icon.svg" />
                      <h5 className="ml-3">Who</h5>
                    </div>
                  }
                  key="who"
                >
                  <div className="sub-cards-2">
                    {cadExtendedSections?.["who"]?.map((row, j) => (
                      <Row className={"mt-3"} key={j}>
                        {row?.Cols.map((col, k) => (
                          <Col
                            span={col.ColSize}
                            className={k !== row?.Cols.length - 1 && "pr-2"}
                            xs={24}
                            sm={col.ColSize}
                            key={k}
                          >
                            <RenderFields
                              data={col}
                              projects={projects}
                              addOtherLocation={addOtherLocation}
                              onProjectChange={onProjectChange}
                              onCustomerSearch={getCustomer}
                              adminRoles={adminRoles}
                              customerDisabled={
                                selectedCustomerId !== undefined &&
                                selectedCustomerId !== ""
                              }
                              dispatchDisabled={date !== undefined}
                            />
                          </Col>
                        ))}
                      </Row>
                    ))}
                  </div>
                </Panel>
              )}

              {cadSections?.map((section, i) => (
                <Panel
                  header={
                    <div className="d-flex">
                      <h5 className="ml-3">{section.sectionName}</h5>
                    </div>
                  }
                  key={section.sectionName}
                >
                  <div className="sub-cards-2">
                    {section?.Rows.map((row, j) => (
                      <Row className={j > 0 ? "mt-3" : ""} key={j}>
                        <React.Fragment>
                          {!row.isMulti &&
                            row?.Cols.map((col, k) => (
                              <Col
                                span={col.ColSize}
                                className="pr-2"
                                xs={24}
                                sm={col.ColSize}
                                key={k}
                              >
                                <RenderFields
                                  data={col}
                                  projects={projects}
                                  addOtherLocation={addOtherLocation}
                                  onProjectChange={onProjectChange}
                                  onCustomerSearch={getCustomer}
                                  adminRoles={adminRoles}
                                  customerDisabled={
                                    selectedCustomerId !== undefined &&
                                    selectedCustomerId !== ""
                                  }
                                  dispatchDisabled={date !== undefined}
                                />
                              </Col>
                            ))}

                          {row.isMulti && (
                            <MultiInput
                              listName={`${section.sectionName}MultiRow${j}`}
                              cols={row?.Cols}
                              RenderFields={RenderFields}
                              customerDisabled={
                                selectedCustomerId !== undefined &&
                                selectedCustomerId !== ""
                              }
                              dispatchDisabled={date !== undefined}
                              projects={projects}
                              addOtherLocation={addOtherLocation}
                              onProjectChange={onProjectChange}
                              adminRoles={adminRoles}
                            />
                          )}
                        </React.Fragment>
                      </Row>
                    ))}
                  </div>
                </Panel>
              ))}
            </Collapse>

            {selectedResponders && selectedResponders.length > 0 && (
              <Row className="mt-3">
                <Col span={24}>
                  <h4>Responder</h4>
                  {selectedResponders &&
                    selectedResponders.map((responder, index) => (
                      <Row className="responder-item mt-3">
                        <Col span={4}>
                          <img
                            src={`/images/users/user-1.png`}
                            alt=""
                            width="50"
                            height="50"
                          />
                        </Col>
                        <Col span={8}>
                          <h5>{`${responder?.profile?.firstName} ${responder?.profile?.lastName}`}</h5>
                          <p>ID: {responder?.beamIds?.[0]}</p>
                        </Col>
                        <Col span={6}>
                          <Button className="beam-btn action-btn">
                            Responders
                          </Button>
                        </Col>
                        <Col span={6} className="t-right">
                          <Button className="beam-btn mr-2">
                            <img
                              src={`/images/flag-green.png`}
                              alt=""
                              width="15"
                              height="15"
                            />
                          </Button>
                        </Col>
                      </Row>
                    ))}
                </Col>
              </Row>
            )}

            {selectedAssets && selectedAssets.length > 0 && (
              <Row className="mt-3">
                <Col span={24}>
                  <h4>Assets</h4>
                  {selectedAssets &&
                    selectedAssets
                      .filter((x) => {
                        return x.assetType === "fixedAsset";
                      })
                      .map((asset, index) => (
                        <Row className="responder-item mt-3">
                          <Col span={4}>
                            <ReactSVG src="/images/map-line-icon.svg" />
                          </Col>
                          <Col span={8}>
                            <h5>{asset.location?.attributes?.title}</h5>
                            <p>{asset.location?.attributes?.description}</p>
                          </Col>
                          <Col span={6}>
                            <Button className="beam-btn action-btn">
                              Asset
                            </Button>
                          </Col>
                          <Col span={6} className="t-right"></Col>
                        </Row>
                      ))}
                </Col>
              </Row>
            )}

            {selectedAssets && selectedAssets.length > 0 && (
              <Row className="mt-3">
                <Col span={24}>
                  <h4>POIs</h4>
                  {selectedAssets &&
                    selectedAssets
                      .filter((x) => {
                        return x.assetType === "poi";
                      })
                      .map((asset, index) => (
                        <Row className="responder-item mt-3">
                          <Col span={4}>
                            <ReactSVG src="/images/map-star-icon.svg" />
                          </Col>
                          <Col span={8}>
                            <h5>{asset.location?.attributes?.title}</h5>
                            <p>{asset.location?.attributes?.description}</p>
                          </Col>
                          <Col span={6}>
                            <Button className="beam-btn action-btn">Poi</Button>
                          </Col>
                          <Col span={6} className="t-right"></Col>
                        </Row>
                      ))}
                </Col>
              </Row>
            )}
          </div>

          {error && (
            <Form.Item>
              <p className="error">{error}</p>
            </Form.Item>
          )}
          <Row className="action-grp mt-4">
            <Col span={8} className="pl-2" xs={24} sm={8}>
              <Button className="beam-btn orange-btn bordered w-full">
                Transfer
              </Button>
            </Col>
            <Col
              span={8}
              xs={24}
              sm={8}
              className="px-2"
              onClick={() => {
                // onSave();
              }}
            >
              <Button
                className="beam-btn yellow-btn cover w-full"
                loading={saving}
              >
                Save
              </Button>
            </Col>
            <Col span={8} className="pr-2" xs={24} sm={8}>
              <Form.Item>
                <Button
                  className="beam-btn green-btn cover w-full"
                  htmlType="submit"
                  loading={searching}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>

      {assistModalVisible && (
        <ConfirmationModal
          onClose={() => {
            setAssistModalVisible(false);
          }}
          handleConfirm={() => {
            // const query = new URLSearchParams(search);
            // const pageId = query.get("assistPageId");
            setAssistPageId(encrypted_token?.assistPageId);
            setAssistModalVisible(false);
          }}
          message={`Do you want to add assist user to the event page?`}
        />
      )}
    </div>
  );
};

export default DispatchPanel;
